export const ROLE_CONSTANTS = {
    // Define your roles
    SA: 1, //Super Admin
    HO: 2, //Head
    DSE: 3, //DSE
    DC: 4, //Digital Champion
    OM: 5, //Outlet Manager
    ZM: 6, //Zone Manager
    RM: 7, //Region Manager
    AM: 8, //Area Manager
    PD: 9, //Parent Dealer
    DP: 10 //Dealer Principal

};
export const ROLE_STAGE_ID = {
    DSE: [9, 10, 12, 13, 14, 15, 16],
    DC: [2, 4, 5, 6, 7, 14, 15, 16]
}
export const ROLE_GROUP_CONSTANTS = {
    SIDEBAR_MENU: [ROLE_CONSTANTS.HO, ROLE_CONSTANTS.OM, ROLE_CONSTANTS.ZM, ROLE_CONSTANTS.RM, ROLE_CONSTANTS.AM, ROLE_CONSTANTS.PD, ROLE_CONSTANTS.DP],
    SIDEBAR_REPORTS: [ROLE_CONSTANTS.HO, ROLE_CONSTANTS.ZM, ROLE_CONSTANTS.RM, ROLE_CONSTANTS.AM, ROLE_CONSTANTS.DP],
    ADVANCED_OUTLET: [ROLE_CONSTANTS.OM, ROLE_CONSTANTS.AM, ROLE_CONSTANTS.PD, ROLE_CONSTANTS.DP],
    FILTER_BAR: [ROLE_CONSTANTS.HO, ROLE_CONSTANTS.ZM, ROLE_CONSTANTS.RM],
    DIR_FILTER_BAR: [ROLE_CONSTANTS.HO, ROLE_CONSTANTS.ZM, ROLE_CONSTANTS.RM, ROLE_CONSTANTS.AM, ROLE_CONSTANTS.DP],
    FILTER_BAR_REGIONAL: [ROLE_CONSTANTS.HO, ROLE_CONSTANTS.ZM],
    GEOGRAPHY_CHART_DEALER: [ROLE_CONSTANTS.AM, ROLE_CONSTANTS.PD],
    GEOGRAPHY_CHART_OUTLET: [ROLE_CONSTANTS.OM, ROLE_CONSTANTS.DP]
};
